<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';

    import ReviewsView from './Reviews.View.svelte';

    import type { ReviewsContent } from '$lib/types/Components/Reviews/ReviewsContent';
    import type { Theme, TransitionEffect } from '$lib/types/Theme';

    export let id = '';
    export let theme: Theme;
    export let content: ReviewsContent;
    export let transitionDelay = 0;
    export let transitionEffect: TransitionEffect = 'none';
    export let layout = DEFAULT_LAYOUT;
</script>

<ReviewsView
    {id}
    box={content.box}
    images={content.images}
    showStars={content.showStars}
    showImages={content.showImages}
    rating={content.rating}
    color={content.color}
    align={content.align}
    wysiwygHtml={content.wysiwygHtml}
    {transitionDelay}
    {transitionEffect}
    {layout}
    {theme}
/>
